import { Link } from "react-router-dom";
import { admins } from "../../../Constant";
import { dateTimeFieldToDate, getUser } from "../../../Utils/externalFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";
import { Edit, Trash2 } from "react-feather";
import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import ModalBuatPengumuman from "../components/Pengumuman/ModalBuatPengumuman";
import ModalDeletePengumuman from "../components/Pengumuman/ModalDeletePengumuman";

const TableColumnsAnnouncement = (getPengumumanList) => {
  const [dropdownOpen, setDropdownOpen] = useState(null)
  const [modalDelete, setModalDelete] = useState(null);
  const [modalEdit, setModalEdit] = useState(null);

  const toggleDropdown = (id) => setDropdownOpen(dropdownOpen === id ? null : id) 
  const toggleDelete = (id) => setModalDelete(modalDelete === id ? null : id);
  const toggleEdit = (id) => setModalEdit(modalEdit === id ? null : id);

  const admin = localStorage.getItem("isAdmin")

  const columns = [
    {
      name: <DataTableTitle text={"Judul"} />,
      selector: (row) => row.title,
      width: "30%",
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Dibuat"} />,
      selector: (row) => dateTimeFieldToDate(row.date_created),
      sortable: true,
      wrap: true,
    },
  ];

  // if (admin) {
    columns.push({
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <div>
          <Dropdown
            toggle={() => toggleDropdown(row?.id_pengumuman)}
            isOpen={dropdownOpen === row?.id_pengumuman}
          >
            <DropdownToggle>&#9660;</DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => toggleEdit(row?.id_pengumuman)}>Edit</DropdownItem>
              <DropdownItem onClick={() => toggleDelete(row?.id_pengumuman)}>Delete</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <ModalBuatPengumuman
            resetState={getPengumumanList}
            data={row}
            toggle={() => toggleEdit(row?.id_pengumuman)}
            isOpen={modalEdit === row?.id_pengumuman}
          />
          <ModalDeletePengumuman
            refreshState={getPengumumanList}
            data={row}
            toggle={() => toggleDelete(row?.id_pengumuman)}
            isOpen={modalDelete === row?.id_pengumuman}
          />
        </div>
      )
    });
  // }

  return columns;
};

export default TableColumnsAnnouncement;
